import { Link } from "react-router-dom";
import { Phone, MessageCircle, Mail } from "lucide-react";

const WHATSAPP_NUMBER = "919270425109";
const PHONE_NUMBER = "+919270425109";
const EMAIL = "support@carecrony.com";

const footerLinks = [
  {
    title: "Services",
    links: [
      { label: "Patients & Elderly Care", href: "/services/patients-elderly-care", isRoute: true },
      { label: "Home Nursing", href: "/services/home-nursing", isRoute: true },
      { label: "Nanny / Baby Sitting", href: "/services/nanny-baby-sitting", isRoute: true },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "How It Works", href: "/#how-it-works" },
      { label: "Why Choose Us", href: "/#why-us" },
      { label: "Testimonials", href: "/#testimonials" },
      { label: "FAQ", href: "/#faq" },
      { label: "Join Us", href: "/#join-us" },
      { label: "Contact", href: "/#contact" },
    ],
  },
  {
    title: "Legal",
    links: [
      { label: "Privacy Policy", href: "/privacy-policy", isRoute: true },
      { label: "Terms & Conditions", href: "/terms-conditions", isRoute: true },
    ],
  },
];

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#0F172A] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-12">
          <div className="md:col-span-2">
            <div className="flex flex-col items-start mb-6">
              <img
                src="/images/logo-full.svg"
                alt="CareCrony Logo"
                className="h-8 md:h-10 w-auto object-contain"
              />
              <span className="text-[8px] md:text-[10px] font-bold text-[#dd6b8e] tracking-[0.15em] uppercase -mt-1 ml-10 font-body">
                Care Giving Services
              </span>
            </div>
            <p className="text-sm leading-relaxed text-slate-400 font-body max-w-sm mb-6">
              Trusted home healthcare services across India. Compassionate, verified caregivers for your loved ones.
            </p>
            <div className="flex gap-3">
              <a href={`tel:${PHONE_NUMBER}`} data-testid="footer-call"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#14B8A6] transition-colors">
                <Phone className="w-4 h-4" />
              </a>
              <a href={`https://wa.me/${WHATSAPP_NUMBER}`} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#25D366] transition-colors">
                <MessageCircle className="w-4 h-4" />
              </a>
              <a href={`mailto:${EMAIL}`} data-testid="footer-email"
                className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-[#14B8A6] transition-colors">
                <Mail className="w-4 h-4" />
              </a>
            </div>
          </div>

          {footerLinks.map((group) => (
            <div key={group.title}>
              <h4 className="font-heading text-sm font-semibold uppercase tracking-wider text-white mb-4">
                {group.title}
              </h4>
              <ul className="space-y-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    {link.isRoute ? (
                      <Link to={link.href} className="text-sm text-slate-400 hover:text-white transition-colors font-body">
                        {link.label}
                      </Link>
                    ) : (
                      <a href={link.href} className="text-sm text-slate-400 hover:text-white transition-colors font-body">
                        {link.label}
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-sm text-slate-500 font-body">
            &copy; {new Date().getFullYear()} CareCrony. All rights reserved.
          </p>
          <p className="text-xs text-slate-600 font-body">
            Home Care &middot; Elder Care &middot; Nursing &middot; Nanny Services in India
          </p>
        </div>
      </div>
    </footer>
  );
}
